import React from 'react';
import { createRoot } from 'react-dom/client';
import { Select, ConditionalSelectSet } from '@bolt/react-select';

const productData = [
  {
    value: 'd014f1e2-cb0b-4562-a7a4-6c568a9cf377',
    label: 'Pega Next-Best-Action Advisor for Financial Services (Parent)',
    'data-url': '#',
    children: [
      {
        value: '597dd56c-48c9-4201-a929-77882e6b0cc0',
        label: '8.3',
        'data-url': '#',
      },
      {
        value: '1bce4a1c-9d30-4077-9e36-eb5b292833c5',
        label: '8.4',
      },
      {
        value: '8919c585-2fec-4eac-8ec0-60816cb1f7eb',
        label: '7.4',
      },
      {
        value: '0522d863-c141-4226-914f-a71166f5d097',
        label: '7.31',
      },
      {
        value: '7d7d25e8-4a92-4cfd-9d20-6449ae7c09e9',
        label: '7.22',
      },
      {
        value: '88a07659-b02f-4f91-a5fc-42834ba1933d',
        label: '7.21',
      },
      {
        value: '0e65d1a3-4ab6-4909-9a02-d39d4ceac7e0',
        label: '7.13',
      },
      {
        value: '5b18e3e5-578f-485a-9891-4fbe649a8314',
        label: '7.12',
      },
      {
        value: '9660c3f9-a527-4a65-a1aa-718af3658379',
        label: '8.1',
      },
      {
        value: '0cff828e-c277-4dc5-9bc5-2dd00b2565b6',
        label: '8.2',
      },
    ],
  },
  {
    value: '47baa7e2-1718-4456-a7e4-f7a3fbffd68b',
    label: 'Pega Adaptive Decision Manager (Parent)',
    children: [
      {
        value: '6691e512-16ff-4eef-827d-9563617c2c9f',
        label: '7.2.1',
      },
      {
        value: 'ba73d4f4-1505-4c65-8935-2c065a579995',
        label: '7.2',
      },
    ],
  },
  {
    value: '2cd0c6dc-4932-4989-8b30-d8c1f17f4ded',
    label: 'Pega B2C Marketing for Communications (Single)',
  },
  {
    value: '9df4eefb-fe6f-4ecf-88b0-54852e7b2ef7',
    label: 'Pega B2C Retention for Communications (Single)',
  },
  {
    value: '0366a5ef-5483-42a5-a958-e71bf972d676',
    label: 'Pega Event Strategy Manager (Single)',
  },
  {
    value: 'd80785de-1dc1-4a44-b2c4-e4cb7a86635d',
    label: 'Pega Marketing (Parent)',
    children: [
      {
        value: '316d4b6a-ae19-4c61-b4bd-946dd41446a2',
        label: '8.3',
      },
      {
        value: '075519dd-e6d2-4cd6-ab33-60532d3dc284',
        label: '8.4',
      },
      {
        value: '7f36ccfa-aded-48ce-b609-2a5f022edd3c',
        label: '7.31',
      },
      {
        value: 'a699923f-7691-4156-bbab-0a1cc509f8dd',
        label: '7.22.1',
      },
      {
        value: 'ab14bea2-3bf2-4c12-94a9-a27e0e1432c2',
        label: '7.22',
      },
      {
        value: 'e6a04ab4-4b67-4c97-879d-9968102d012b',
        label: '7.21',
      },
      {
        value: 'd8291d85-f2a6-47c3-8efa-4ed43e04e7eb',
        label: '7.13',
      },
      {
        value: '6e0b077f-cf3a-4072-8960-3342b79946fd',
        label: '7.12',
      },
      {
        value: 'a54ed56a-5770-4cf9-92ed-9ab82db6be8c',
        label: '7.11 ML 1',
      },
      {
        value: '63a1856e-e3e5-454b-b219-0f46a4a6cba5',
        label: '7.11',
      },
      {
        value: '031c32ea-d921-49d5-82bd-84e3b7496741',
        label: '6.3.1',
      },
      {
        value: '5bbec539-52b3-4ca0-853b-a3430fc6a15d',
        label: '6.3',
      },
      {
        value: 'b861c5cb-a836-4cc3-9e25-bee240f06d5e',
        label: '6.2',
      },
      {
        value: '80b7c198-afb6-4956-b0a0-d3dfbc6cdf5b',
        label: '7.4',
      },
      {
        value: 'f3a54ead-4723-4fd3-817c-7ba1a2e6da5d',
        label: '8.1',
      },
      {
        value: 'fba1f069-2f56-4797-a6f7-43de06d1d503',
        label: '8.2',
      },
    ],
  },
  {
    value: 'b5bf2e32-9ccb-4f6f-9931-8e93957d9ff8',
    label: 'Pega Marketing for Communications (Parent)',
    children: [
      {
        value: 'd069d23a-6a6c-4abc-bf32-746882726676',
        label: '8.3',
      },
      {
        value: '348fd04a-0290-48c1-ae32-46bb44dde060',
        label: '8.4',
      },
      {
        value: '784ecb59-b8cb-4ace-ac5d-203e6beda491',
        label: '7.31',
      },
      {
        value: 'aa53fbd3-6ae9-45e6-928c-7538e59cf64c',
        label: '7.22.1',
      },
      {
        value: '6717043c-3370-443a-9bd4-9ff490f4bbbc',
        label: '7.22',
      },
      {
        value: 'f0d322b7-55f0-448d-b29c-15e42e8161df',
        label: '7.21',
      },
      {
        value: '45c2b7cd-eefe-4a88-a592-ff7ae3b8a6d1',
        label: '7.13',
      },
      {
        value: '0ef655e3-bff2-44ca-9f46-380ad5bee2ee',
        label: '7.12',
      },
      {
        value: 'ddc0f8a9-f52b-43ac-8369-84c86fc092f1',
        label: '7.4',
      },
      {
        value: 'c69a72e4-163b-4252-95d8-ef7bc0bfee4d',
        label: '8.1',
      },
      {
        value: '30ebedad-3bad-42b5-8489-a982b70c7af6',
        label: '8.2',
      },
    ],
  },
];

const conditionalSelectData = {
  product_select: {
    name: 'product_select',
    label: 'Product',
    childLabel: 'Version(s)',
    placeholder: 'Product',
    childPlaceholder: 'Version(s)',
    addMoreLabel: 'Add Product',
    isClearable: true,
    options: productData,
    childIsMulti: true,
    defaultValue: [],
    delimiter: ',',
  },
  product_select_selected: {
    name: 'product_select_selected',
    placeholder: 'Product',
    childPlaceholder: 'Version(s)',
    addMoreLabel: 'Add Product',
    isClearable: true,
    options: productData,
    defaultValue: [
      {
        value: 'd014f1e2-cb0b-4562-a7a4-6c568a9cf377',
        label: 'Pega Next-Best-Action Advisor for Financial Services',
      },
      {
        value: '597dd56c-48c9-4201-a929-77882e6b0cc0',
        label: '8.3',
      },
      {
        value: '47baa7e2-1718-4456-a7e4-f7a3fbffd68b',
        label: 'Pega Adaptive Decision Manager',
      },
      {
        value: '9df4eefb-fe6f-4ecf-88b0-54852e7b2ef7',
        label: 'Pega B2C Retention for Communications',
      },
    ],
  },
  product_select_single: {
    name: 'product_select_single',
    placeholder: 'Product',
    childPlaceholder: 'Version(s)',
    addMoreLabel: 'Add Product',
    childIsMulti: false,
    isClearable: true,
    options: productData,
    defaultValue: [
      {
        value: 'd014f1e2-cb0b-4562-a7a4-6c568a9cf377',
        label: 'Pega Next-Best-Action Advisor for Financial Services',
      },
      {
        value: '597dd56c-48c9-4201-a929-77882e6b0cc0',
        label: '8.3',
      },
      {
        value: '47baa7e2-1718-4456-a7e4-f7a3fbffd68b',
        label: 'Pega Adaptive Decision Manager',
      },
      { value: '6691e512-16ff-4eef-827d-9563617c2c9f', label: '7.2.1' },
      {
        value: '9df4eefb-fe6f-4ecf-88b0-54852e7b2ef7',
        label: 'Pega B2C Retention for Communications',
      },
    ],
  },
};

const App = () => {
  return (
    <>
      <h2>Conditional Select Demo</h2>
      <form className="c-bolt-form">
        <fieldset className="c-bolt-fieldset">
          <legend className="c-bolt-legend u-bolt-visuallyhidden">
            <h2 className="c-bolt-headline c-bolt-headline--bold c-bolt-headline--uppercase c-bolt-headline--small">
              Product selector
            </h2>
          </legend>
          <div className="c-bolt-input-list">
            <div className="c-bolt-input-list__item">
              <label className="c-bolt-block-label" htmlFor="single-select">
                <strong>Conditional select (empty)</strong>
              </label>
              <div className="c-bolt-block-input-wrapper">
                <ConditionalSelectSet
                  {...conditionalSelectData.product_select}
                />
              </div>
            </div>
            <div className="c-bolt-input-list__item">
              <label className="c-bolt-block-label" htmlFor="single-select">
                <strong>Conditional select (options selected)</strong>
              </label>
              <div className="c-bolt-block-input-wrapper">
                <ConditionalSelectSet
                  {...conditionalSelectData.product_select_selected}
                />
              </div>
            </div>
            <div className="c-bolt-input-list__item">
              <label className="c-bolt-block-label" htmlFor="single-select">
                <strong>Conditional select (isMulti false)</strong>
              </label>
              <div className="c-bolt-block-input-wrapper">
                <ConditionalSelectSet
                  {...conditionalSelectData.product_select_single}
                />
              </div>
            </div>
          </div>
        </fieldset>
      </form>
    </>
  );
};

const selector = '#bolt-conditional-select-demo';
const target = document.querySelector(selector);

if (target) {
  const root = createRoot(target);
  root.render(<App />);
}
